"use client"

import { useResponsive } from "@/core-nextv3/util/useResponsive";
import dynamic from "next/dynamic";

const FooterDesk = dynamic(() => import("../Footer/FooterDesk").then((mod) => mod.FooterDesk), 
    {
        ssr : false,
    });

const FooterMenu = dynamic(() => import("../Views/mobile/components/Footer").then((mod) => mod.FooterMenu), 
    {
        ssr : false,
    });

const FooterMobile = dynamic(() => import("../Footer/FooterMobile").then((mod) => mod.FooterMobile), 
    {
        ssr : false,
    });

const FooterLayout = ({ ref }:any) => 
{
    const { isDesktop } = useResponsive();

    return (
        <div className="footer" ref={ref}>
            {isDesktop ? <FooterDesk/> : <><FooterMenu/><FooterMobile/></>}
        </div> 
    );
}

export { FooterLayout };
